import React from 'react';
import { WellnessImage } from './ui/WellnessImage';

const stages = [
  { image: 'test', label: 'TEST', title: 'Find Your Starting Point', description: 'Complete intake. The team helps select your panel, confirms testing, bills directly and arranges your home kit.' },
  { image: 'connect', label: 'CONNECT YOUR DATA', title: 'Bring the Picture Together', description: 'Combine labs, health history and goals, with wearable data and DNA insights when available.' },
  { image: 'understand', label: 'UNDERSTAND', title: 'Put Results in Context', description: 'The team considers your available information together, rather than lab results in isolation.' },
  { image: 'personalize', label: 'PERSONALIZE', title: 'Build Your Protocol', description: 'Turn that fuller picture into wellness guidance tailored to your priorities.' },
  { image: 'act', label: 'ACT', title: 'Take Your Next Step', description: 'Review your personalized protocol and next steps with the team.' },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="hbk-section" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4">
        <p className="section-marker" data-testid="how-it-works-label">HOW IT WORKS</p>
        <h2 className="section-heading mb-8" data-testid="how-it-works-heading">From Testing to Taking Action</h2>
        <ol className="hbk-journey" aria-label="Test, connect your data, understand, personalize, act" data-testid="customer-journey">
          {stages.map(({ image, label, title, description }, i) => (
            <li className="hbk-journey-step" key={label} data-testid={`step-0${i + 1}`}>
              <span className="hbk-journey-number" aria-hidden="true" data-testid={`step-number-0${i + 1}`}>0{i + 1}</span>
              <WellnessImage name={image} testId={`step-image-0${i + 1}`} className="hbk-journey-image" sizes="(max-width: 639px) 84px, (max-width: 1023px) 140px, (min-width: 1440px) 250px, 20vw" />
              <div className="hbk-journey-copy">
                <p className="hbk-journey-label" data-testid={`step-label-0${i + 1}`}>{label}</p>
                <h3 className="hbk-journey-title" data-testid={`step-title-0${i + 1}`}>{title}</h3>
                <p className="hbk-journey-description" data-testid={`step-description-0${i + 1}`}>{description}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}